import { render } from "./TicketForm.vue?vue&type=template&id=a3e4b506"
import script from "./js/ticketForm.js?vue&type=script&lang=js&external"
export * from "./js/ticketForm.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__